import React from "react";
// import Helmet from "../component/common/HelmetDelete";
import {Helmet} from 'react-helmet'
import HeaderThree from "../component/header/HeaderThree";
import FooterTwo from "../component/footer/FooterTwo";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import ContactOne from "../elements/contact/ContactOne";
import {
  Row,
  Col,
  Card,
  CardBody,
  Progress,
  UncontrolledTooltip,
  Button,
  Alert,
  FormGroup,
} from "reactstrap";
import Faqs from "../elements/faq/FaqList";
import { useTranslation } from "react-i18next";

const FaqsLanding = () => {
  const { t, i18n } = useTranslation();
  const icon = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive.webp`;

  return (
    <div className="active-dark bg_color--ugs">
      <Helmet>
        <title>EcoShift</title>
        <meta name="description" content="EcoShift ⁕ the digital platform for your eco-positive consumption!" />
        <meta name="keywords" content= "ecoshift,shift,impact,transition,eco,friendly,consumption,eco-positive,sustainability,biodiversity,ecoresponsible" />
        <meta property="og:title" content="eco shift" />
        <meta property="og:description" content="EcoShift ⁕ the digital platform for your eco-positive consumption!" />
        <meta property="og:image" content={icon} />
        <meta property="og:url" content={process.env.PUBLIC_URL + "/"} />
        <meta name="twitter:card" content={icon} />
        <meta name="robots" content="index, follow"/>
        <link rel="canonical" href="https://ecoshift.eco/faqs" />
      </Helmet>
      
      <HeaderThree
        homeLink="/"
        logo="symbol-dark"
        color="color-black"
        alwaysSticky="true"
      />
      <Card id="faqs" className="pt-100">
        <CardBody>
          <div className="service-area creative-service-wrapper pb--120">
            <div className="container">
              <div className="row">
                <div className="flex justify-content-center col-lg-12 align-items-center">
                  <div className="section-title align-horizontal text-center mb--30 mb_sm--0">
                    <p className="section-title">{t("FAQs")}</p>
                  </div>
                </div>
              </div>
              <br />
              <Faqs />
              <div className="header-btn mt-50 flex justify-content-center"></div>
            </div>
          </div>
        </CardBody>
      </Card>
      <FooterTwo homeLink="/" logo="symbol-dark" color="color-black" />
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
    </div>
  );
};

export default FaqsLanding;
